"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ProductLongDescription = _interopRequireDefault(require("@sprinx/react-com/ProductLongDescription"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useProductLongDescription = _interopRequireDefault(require("./useProductLongDescription"));

function ProductDetailLongDescription(_ref) {
  var product = _ref.product;
  var t = (0, _useTranslate.default)();

  var _useProductLongDescri = (0, _useProductLongDescription.default)(product.id),
      body = _useProductLongDescri.body;

  return body ? /*#__PURE__*/_react.default.createElement(_ProductLongDescription.default, {
    content: body
  }) : t('productDetailSpagettyNavigation/productDescriptionNotAvailable');
}

process.env.NODE_ENV !== "production" ? ProductDetailLongDescription.propTypes = {
  product: _propTypes.default.shape({
    id: _propTypes.default.string
  }).isRequired
} : void 0;
var _default = ProductDetailLongDescription;
exports.default = _default;